import { render, staticRenderFns } from "./NotificationBlock.vue?vue&type=template&id=2699ecfb&scoped=true&"
import script from "./NotificationBlock.vue?vue&type=script&lang=js&"
export * from "./NotificationBlock.vue?vue&type=script&lang=js&"
import style0 from "./NotificationBlock.vue?vue&type=style&index=0&id=2699ecfb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2699ecfb",
  null
  
)

export default component.exports